// Data Schema
import apiClient from "../../../helpers/api-client";
import { AccountType } from "../../../helpers/account";

export const ROLE_CATEGORIES = ["ADMIN", "INSTRUCTOR", "STUDENT"] as const;
export type RoleCategory = (typeof ROLE_CATEGORIES)[number];

export type PrivilegeGroup = {
	id: number;
	name: string;
};

export type RosterUser = Awaited<ReturnType<typeof apiClient.user.getAccessControlUserInfo>>;

export type BaseRosterAccount = Awaited<ReturnType<typeof apiClient.authentication.getAccount>> & { type: AccountType };
export type Lti1p3Account = BaseRosterAccount & {
	type: "lti";
	instituteId: string;
	lmsUserId: string;
	secondaryLmsUserId: string;
	nrpsPrivilegeGroupMappingEnabled: boolean;
};
export type SamlAccount = BaseRosterAccount & {
	type: "saml";
	registrationId: string;
	samlPrivilegeGroupMappingEnabled: boolean;
};
export type BasicAuthAccount = BaseRosterAccount & { type: "verity" };
export type StandaloneAccount = BaseRosterAccount & { type: "standalone" };
export type RosterAccount = Lti1p3Account | SamlAccount | BasicAuthAccount | StandaloneAccount;

export type RosterStatistics = { total: number; admin: number; instructor: number; student: number };

// Filter
export type RosterFilterQuery = {
	role: RoleCategory[];
	locked: boolean[];
};

export type RosterSearchQuery = {
	idOrEmail?: string;
};

// Sorting
export type RosterSortKey = "name" | "email" | "privilegesLocked";
export type RosterSortDirection = "asc" | "desc";

export interface RosterSortConfig {
	key: RosterSortKey;
	direction: RosterSortDirection;
}

// State
export type RosterState = {
	searchQuery: RosterSearchQuery;
	filterQuery: RosterFilterQuery;
	sortConfigs: RosterSortConfig[];
	currentPage: number;
	pageSize: number;
};
